var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowLeftWhiteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30384 0.678845C8.59255 0.439459 8.96476 0.324036 9.33822 0.358532C9.71167 0.393028 10.0561 0.574218 10.296 0.862439C10.5354 1.15115 10.6501 1.52336 10.6156 1.89681C10.5811 2.27027 10.3999 2.61465 10.1117 2.85463L3.95228 7.96713L10.1117 13.0788C10.3999 13.3188 10.5811 13.6632 10.6156 14.0367C10.6501 14.4101 10.5354 14.7823 10.296 15.071C10.0561 15.3593 9.71167 15.5404 9.33822 15.5749C8.96476 15.6094 8.59255 15.494 8.30384 15.2546L0.839778 9.06244L0.647591 8.87884C0.408204 8.59013 0.293563 8.21793 0.328059 7.84447C0.362556 7.47101 0.543745 7.12663 0.831965 6.88666L8.30384 0.678845Z",
    fill: "#FEFEFE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeftWhiteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowLeftWhiteIcon.ef52f2e1.svg";
export { ForwardRef as ReactComponent };